import { setState } from '../actions';
import { initialState } from '../reducers';
import { put } from 'redux-saga/effects';

export function* resetCompanyLibraryState() {
  yield put(setState(initialState))
}
